import { render, staticRenderFns } from "./ForgotPasswordLogListView.vue?vue&type=template&id=c6f346c2"
import script from "./ForgotPasswordLogListView.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordLogListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports